export default [
  {
    tema: { label: 'Agua Potable Ap', id: 'Agua_Potable_AP' },
    subtema: [
      { label: 'Calidad AP', id: 'Calidad AP' },
      { label: 'Déficit Hídrico', id: 'Déficit Hídrico' },
      { label: 'Redes AP', id: 'Redes AP' },
      { label: 'Presión', id: 'Presión' },
      { label: 'Fuentes', id: 'Fuentes' },
      { label: 'Grifos', id: 'Grifos' },
      { label: 'Medición', id: 'Medición' },
      { label: 'Producción', id: 'Producción' },
      { label: 'PTAP', id: 'PTAP' }
    ]
  },
  {
    tema: { label: 'Informativo', id: 'Informativo' },
    subtema: [
      { label: 'Informativo', id: 'Informativo' },
      { label: 'Instructivo', id: 'Instructivo' }
    ]
  },
  {
    tema: { label: 'Aguas Servidas', id: 'Aguas_Servidas' },
    subtema: [
      { label: 'By Pass', id: 'By Pass' },
      { label: 'Redes AS', id: 'Redes AS' },
      { label: 'PTAS', id: 'PTAS' },
      { label: 'Plan de Invierno', id: 'Plan De Invierno' },
      { label: 'Riles', id: 'Riles' },
      { label: 'Calidad AS', id: 'Calidad AS' },
      { label: 'Aguas Grises', id: 'Aguas Grises' }
    ]
  },
  {
    tema: { label: 'Nuevos Servicios', id: 'Nuevos_Servicios' },
    subtema: [
      { label: 'Factibilidad', id: 'Factibilidad' },
      { label: 'Ampliación de concesión', id: 'Ampliación de concesión' }
    ]
  },
  {
    tema: { label: 'Fiscalización', id: 'Fiscalización' },
    subtema: [
      { label: 'Fiscalización', id: 'Fiscalización' }
    ]
  },
  {
    tema: { label: 'Planes de Desarrollo', id: 'Planes_de_Desarrollo' },
    subtema: [
      { label: 'Planes de Desarrollo', id: 'Planes de Desarrollo' },
      { label: 'Ampliación de Concesión', id: 'Ampliación de Concesión' },
      { label: 'Obras', id: 'Obras' }
    ]
  },
  {
    tema: { label: 'Proceso de Sanción', id: 'Proceso de Sanción' },
    subtema: [
      { label: 'Proceso de Sanción', id: 'Proceso de Sanción' },
    ]
  },
  {
    tema: { label: 'Leyes y Normas', id: 'Leyes y Normas' },
    subtema: [
      { label: 'Servicios Sanitarios', id: 'Servicios Sanitarios' },
      { label: 'Sociedades de Servicios Sanitarios', id: 'Sociedades de Servicios Sanitarios' },
      { label: 'Leyes y Normas', id: 'Leyes y Normas' },
      { label: 'Norma', id: 'Norma' }
    ]
  },
  {
    tema: { label: 'Protocolo', id: 'Protocolo' },
    subtema: [
      { label: 'Protocolo', id: 'Protocolo' }
    ]
  },
  {
    tema: { label: 'SAC', id: 'SAC' },
    subtema: [
      { label: 'Facturación', id: 'Facturación' },
      { label: 'Comercial', id: 'Comercial' },
      { label: 'Cov19', id: 'Cov19' }
    ]
  },
  {
    tema: { label: 'Tarifas', id: 'Tarifas' },
    subtema: [
      { label: 'Tarifas', id: 'Tarifas' }
    ]
  },
  {
    tema: { label: 'Emergencia', id: 'Emergencia' },
    subtema: [
      { label: 'Emergencia', id: 'Emergencia' }
    ]
  },
  {
    tema: { label: 'Compras', id: 'Compras' },
    subtema: [
      { label: 'Licitación', id: 'Licitación' },
      { label: 'Contratos', id: 'Contratos' },
      { label: 'Empresas Relacionadas', id: 'Empresas Relacionadas' },
      { label: 'Servidumbre', id: 'Servidumbre' }
    ]
  },
  {
    tema: { label: 'Medio Ambiente', id: 'Medio Ambiente' },
    subtema: [
      { label: 'Medio Ambiente', id: 'Medio Ambiente' }
    ]
  },
  {
    tema: { label: 'Norma', id: 'Norma' },
    subtema: [
      { label: 'Reglamento', id: 'Reglamento' },
      { label: 'Norma', id: 'Norma' },
      { label: 'NCh-ISO', id: 'NCh-ISO' }
    ]
  },
  {
    tema: { label: 'DFL', id: 'DFL' },
    subtema: [
      { label: 'DFL', id: 'DFL' }
    ]
  }
];
